import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'view-design/dist/styles/iview.css'
import fetch from './fetch/fly'
import { Message } from 'view-design'
import { baseHost } from './config/index'
import './router/intercept'
import GL_Component from '@/utils/globalComponents'

Vue.config.productionTip = false
Vue.prototype.$fetch = fetch
Vue.prototype.$msg = Message

Vue.prototype.baseHost = baseHost

// 全局组件
Vue.use(GL_Component)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
